<template>
  <section class="flex flex-col gap-4 w-full">
    <div
      class="w-full bg-white p-6 rounded-md shadow-md flex flex-wrap gap-2 items-center justify-between"
    >
      <p class="font-[800] text-neutral-900">
        {{ questionCount }}.{{ " " + question?.prompt }}
      </p>
      <MessageVoice
        v-if="playAudio"
        :msg="msgVoice(question.prompt)"
        :scaleIcons="0.8"
        :showIconsName="false"
        @onEndMessage="onSpeak($event)"
      />
    </div>
    <div
      v-for="(item, index) in processedItems"
      :key="item.id"
      class="mb-6 last:mb-0 bg-white p-6 rounded-md shadow-md flex flex-col sm:flex-row sm:items-center gap-2"
    >
      <span class="font-bold">{{ renderLetterItem(index) }}</span>
      <div v-for="(part, index) in item.parts" :key="index">
        <span v-if="part.type === 'text'" v-html="part.content"></span>
        <InputText v-else v-model="part.inputText" maxlength="255"></InputText>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";

interface QuestionPart {
  type: string;
  content?: string;
  correctId?: string;
  inputText: string;
}

interface ProcessedItem {
  id: string;
  parts: QuestionPart[];
}

export default defineComponent({
  name: "QuestionGapsComponent",
  data() {
    return {
      playAudio: true as boolean,
    };
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    answers: {
      type: Object,
      required: true,
    },
    questionCount: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    const processedItems = ref<ProcessedItem[]>(
      props.question.items.map((item: any) => {
        const cleanText = item.answerText.replace(/^<p>|<\/p>$/g, "");
        const parts: QuestionPart[] = [];

        cleanText
          .split(/\[resposta-hidden:([\w-]+)\]/)
          .forEach((segment: string, index: number) => {
            segmentTextAndGap(parts, index, segment);
          });

        return {
          id: item.id,
          parts,
        };
      })
    );

    function segmentTextAndGap(
      parts: QuestionPart[],
      index: number,
      segment: string
    ): void {
      const part: QuestionPart =
        index % 2 === 0
          ? { type: "text", content: segment, inputText: "" }
          : { type: "gap", correctId: segment, inputText: "" };

      parts.push(part);
    }

    function renderLetterItem(index: number) {
      return `${String.fromCharCode(65 + index)}:`;
    }

    function msgVoice(prompt: string): string {
      let result = prompt;
      let alphabetIndex = 0;

      props.question?.items.forEach((element) => {
        const letter = String.fromCharCode(65 + alphabetIndex);

        const plainText = element.answerText
          .replace(/<[^>]*>/g, " ")
          .replace(/\[resposta-hidden:[\w-]+\]/g, " Lacuna a ser preenchida ")
          .trim();

        result += `. Item ${letter}: ${plainText}. `;
        alphabetIndex++;
      });

      return result;
    }
    function onSpeak(event: any): void {
      emit("onSpeak", event);
    }

    function fillAnswer() {
      props.answers.fillInTheBlanksAnswers = [];
      processedItems.value.forEach((item) => {
        item.parts.forEach((part) => {
          if (part.type === "gap") {
            const response = JSON.stringify({
              name: part.inputText.trim(),
              id: part.correctId,
            });
            props.answers.fillInTheBlanksAnswers.push(response);
          }
        });
      });
    }
    watch(processedItems.value, (val) => {
      const isFilledBlanks = val.every((item) =>
        item.parts.every((part) =>
          part.type === "gap" ? part.inputText.length > 0 : true
        )
      );
      if (isFilledBlanks) {
        fillAnswer();
      } else {
        props.answers.fillInTheBlanksAnswers = null;
      }
    });

    return { msgVoice, onSpeak, processedItems, renderLetterItem };
  },
});
</script>
